define('views/hover-title',["require", "exports", "../dom"], function (require, exports, dom_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = void 0;
    /**
     * HTML title attributes don't work on mobile.
     * This script will make them into popups on click.
     */
    function init() {
        var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        if (isMobile) {
            var _loop_1 = function (element) {
                element.addEventListener("click", function () {
                    var title = element.getAttribute("title");
                    if (title) {
                        var tooltip_1 = document.createElement("span");
                        tooltip_1.innerText = title;
                        element.appendChild(tooltip_1);
                        // Close tooltip on click out
                        var closer_1 = function () {
                            element.removeChild(tooltip_1);
                            window.removeEventListener("click", closer_1);
                        };
                        setTimeout(function () { return window.addEventListener("click", closer_1); }, 0);
                    }
                });
            };
            for (var _i = 0, _a = (0, dom_1.q)(".hover-title"); _i < _a.length; _i++) {
                var element = _a[_i];
                _loop_1(element);
            }
        }
    }
    exports.init = init;
});
//# sourceMappingURL=/assets/javascripts/views/hover-title.js.map;
